export default __webpack_public_path__ + "static/media/team-picture-bg.33074bed.jpg";